/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statschathint2Inputs */

const en_statschathint2 = /** @type {(inputs: Statschathint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages people wrote. System lines are not counted.`)
};

const de_statschathint2 = /** @type {(inputs: Statschathint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachrichten, die Menschen geschrieben haben. Systemzeilen zählen nicht.`)
};

/**
* | output |
* | --- |
* | "Messages people wrote. System lines are not counted." |
*
* @param {Statschathint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statschathint2 = /** @type {((inputs?: Statschathint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statschathint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statschathint2(inputs)
	return de_statschathint2(inputs)
});
export { statschathint2 as "statsChatHint" }